import React from "react";
import {MainContainer, SectionContainer, WidgetContainer} from "../CommonStyled/widgets/Styled";
import {VisionContentDiv, VisionStatementWrapper} from "./widgets/Styled";
import Card from "../WidgetCard";
import Anchor from "../HTMLEntities/Anchor";
import config from "../../config/config";

const OurVisionStatmentWidget: React.FC = () => {
    return (
        <MainContainer
            containerStyle={{
                mobile: {margin: "0px auto 0 auto"},
                laptop: {margin: "0px auto 0 auto"},
            }}
        >
            <SectionContainer>
                <WidgetContainer>
                    <VisionStatementWrapper>
                        <Card widgetHeading={"Our Vision Statement"}>
                            <VisionContentDiv>
                                <p>
                                    The vision for Shiksha Study Abroad is to meaningfully
                                    contribute towards building career of Indian students wanting to
                                    study abroad. We do this by connecting students with right
                                    information sources and with experts to will help them in each
                                    step of their journey.
                                </p>
                                <ul>
                                    <li>
                                        Our primary consumers are study abroad aspirants from India
                                        and neighboring countries (both students and their parents,
                                        siblings, families)
                                    </li>
                                    <li>
                                        Our primary product is our study abroad college research
                                        website: {""}
                                        <Anchor
                                            linkHref={`${config.SHIKSHA_STUDYABROAD_HOME}`}
                                            linkLabel={
                                                "Study Abroad - Colleges, Courses, Exams, Free Counseling"
                                            }
                                            target={"_self"}
                                            isPWALink={false}
                                        />{" "}
                                        and our primary service is end to end counseling for
                                        students aspiring to go abroad for studies
                                    </li>
                                    <li>
                                        We are located in Noida and due to our pure online model,
                                        process students from all across the country
                                    </li>
                                    {/* <li>
                                        You can read more about AIRC and can comment about Shiksha
                                        on AIRC website here -
                                        <a
                                            href="https://www.airc-education.org/airc-certified-agencies"
                                            target="blank"
                                        >
                                            AIRC Certified Agencies — AIRC (airc-education.org)
                                        </a>
                                    </li> */}
                                </ul>
                            </VisionContentDiv>
                        </Card>
                    </VisionStatementWrapper>
                </WidgetContainer>
            </SectionContainer>
        </MainContainer>
    );
};

export default OurVisionStatmentWidget;
